import Vue from 'vue'
import lodash from 'lodash'
import { getLanguage } from '@/utils/auth'
const certificationObj = Vue.observable({
    frontOrBackRequest: 'front',
    merchantId: null,
    merchantIntegrateStep: 'step_1',
    type: null,
    shareholders25: 'false',
    kgIsFr: 'true',
    merchantDto: {
      registerAddress: '', //注册地址
      name: '', //企业名称
      merchantNumber: null,
      merchantIntegrateStep: 'step_1',
      proxyMerchantNumber: '', //邀请码
      customerManagerCode: '', //客户经理
      engName: '', //英文名称
      country: '', //所属国家
      industryAttribute: '', //行业属性
      registerPost: '', //邮政编码
      economyType: '', //经济类型
      foreignInvestorCountryCode: [], //外方投资者国别代码
      registerTime: '', //企业注册时间
      merchantLicenseType: '',//公司证件类型
      businessLicenseNumber: '',//营业执照号
      scopeTime: null, // 营业执照有效期
      blPeriodOfValidityFrom: '', //营业执照有效期起始日
      blPeriodOfValidityTo: '', //营业执照有效期终止日
      organizationInstitutions: '', //组织机构号
      registeredFund: '', //注册资金
      operateScope: '', //经营范围
      businessLicenseImage: '', //营业执照
      businessLicenseImageUrl: '',
      operatorIsLegal: false, //是否为法人
      isSpecialEconomyType: true, // 是否特殊经济类型企业
      existCustomsDeclarationBusiness: false, //是否报关
      specialEconomyType: '', //特殊经济类型
    },
    privatePersonDto: { // 个人跨境
      name: '',
      merchantId: null,
      proxyMerchantNumber: '',
      identity: '',
      identityFrom: '',
      identityTo: '',
      scopeTime: [],
      identityFrontImage: '',
      identityBackImage: '',
      identityInHandImage: '',
      identityFrontImageUrl: '',
      identityBackImageUrl: '',
      identityInHandImageUrl: '',
      address: '',
      bankAccountDto: {
        bankAccountNo: '',
        bankName: '',
        phone: ''
      },
      msgCode: ''
    },
    identityInfoDtos: [ //法人经办人信息
      {
        name: '',
        type: 'legal',
        identityFrontImage: '',
        identityBackImage: '',
        identityInHandImage: '',
        identityFrontImageUrl: '',
        identityBackImageUrl: '',
        identityInHandImageUrl: '',
        phone: '',
        identityType: '',
        identity: '',
        identityFrom: '',
        identityTo: '',
        scopeTime: [],
        merchantId: '',
        eMail: '',
        code: '',
        country: '',
        province: '',
        city: '',
        address: '',
        engCountry: '',
        engProvince: '',
        engCity: '',
        engAddress: '',
        engLegalName: ''
      },
      {
        name: '',
        type: 'operator',
        identityFrontImage: '',
        identityBackImage: '',
        identityInHandImage: '',
        identityFrontImageUrl: '',
        identityBackImageUrl: '',
        identityInHandImageUrl: '',
        phone: '',
        identityType: '',
        identity: '',
        identityFrom: '',
        scopeTime: [],
        identityTo: '',
        merchantId: '',
        eMail: '',
        code: '',
        country: '',
        province: '',
        city: '',
        address: '',
      }
    ],
    merchantControlerInfoDto:{
      controlerName:'',
      controlerIdType:'',
      controlerIdNo:'',
      controleIdValidityStart:'',
      controlerValidityEnd:'',
      controlerAddress:'',
      controlerCapital:'',
      controlerDate:'',
      controlerRate:'',
    },
    shareholdersDtos: [ //股东信息
      {
        name: '', //股东名
        merchantId: '', //商户编号
        identity: '', //股东身份证号
        identityBackImage: '', //股东身份证反面
        identityFrontImage: '', //股东身份证正面
        identityBackImageUrl: '',
        identityFrontImageUrl: '',
        identityFrom: '', //股东身份证有效期起始日
        identityTo: '', //股东身份证有效期终止日
        scopeTime: [],
        percentage: '', //股份占比
      }
    ],
    bankAccountDto: {
      name: '', // 公司名称（企业银行账户）
      bankAccountNo: '', // 企业银行账号
      bankId: '', //
      bankName: '',//开户行名称
      bankSwift: '',//开户行行号
      bankCurrency: '', //开户币种
      bankProvince: '', //开户省份
      bankCity: '', //开户城市
      bankCode: '', //开户银行编号
      bankMaterialImage: '',//银行户材料
      bankMaterialImageUrl: '',//银行户材料
      areas: 'internal',//账户地点
      country: ''//国家
    },
    customsDeclarationBusinessDto: {
      firmCustomsRecordNumber: '', //企业海关备案号
      ecCheckoutQuarantineCode: '', //电商企业检验检疫代码
      ecPlatformName: '',//电商平台名称
      ecPlatformCode: '',//电商平台代码
    },

    platformSelfDtos: {
      websiteAddress: '',//平台网站IP地址
      websiteIcpRecord: '',//平台网站ICP备案号
      websiteSecurityRecord: '', //平台网站网安备案号
      name: '',//平台名称
    },
    webchatDtos: [
      {
        name: '', //公众号名称
        code: '', //appid
        authPath: '', //授权目录
        ztName: '', //主体名称
        type: 1,
        merchantId: null
      }
    ],
    wechatMiniProgram: [
      {
        name: '', //小程序名称
        code: '', //appid
        ztName: '', //主体名称
        type: 2,
        merchantId: null
      }
    ],
    platformDtos: [
      {
        name: '', //入驻平台主体名称
        merchantId: null,
        shopWebsiteAddress: '' //入驻平台网址
      }
    ],
    documentDtos: [
      {
        fileId: '',
        fileUrl: '',
        referenceId: null, //merchantId
        referenceType: 'merchant',
        name: getLanguage()==='zh'?'办公场所1':'Office Location 1',
        platfromType: 'alaways',
        code: 'evidence_office_photos1'
      },
      {
        fileId: '',
        fileUrl: '',
        referenceId: null, //merchantId
        referenceType: 'merchant',
        name: getLanguage()==='zh'?'办公场所2':'Office Location 2',
        platfromType: 'alaways',
        code: 'evidence_office_photos2'
      },
      {
        fileId: '',
        fileUrl: '',
        referenceId: null, //merchantId
        referenceType: 'merchant',
        name: getLanguage()==='zh'?'公司标志照':'Company logo',
        platfromType: 'alaways',
        code: 'evidence_company_logo'
      },
      // {
      //   fileId: '',
      //   fileUrl: '',
      //   referenceId: null, //merchantId
      //   referenceType: 'merchant',
      //   name: 'ICP许可证',
      //   platfromType: 'self',
      //   code: 'evidence_icp_licence'
      // },
      {
        fileId: '',
        fileUrl: '',
        referenceId: null, //merchantId
        referenceType: 'merchant',
        name: getLanguage()==='zh'?'ICP备案':'ICP Filing',
        platfromType: 'self',
        code: 'evidence_icp_report'
      },
      // {
      //   fileId: '',
      //   fileUrl: '',
      //   referenceId: null, //merchantId
      //   referenceType: 'merchant',
      //   name: 'EDI许可证',
      //   platfromType: 'self',
      //   code: 'evidence_edi_licence'
      // },
      {
        fileId: '',
        fileUrl: '',
        referenceId: null, //merchantId
        referenceType: 'merchant',
        name: getLanguage()==='zh'?'海关登记证书':'Customs Registration Certificate',
        platfromType: 'customs',
        code: 'evidence_customs_registration_certificate'
      },
      // {
      //   fileId: '',
      //   fileUrl: '',
      //   referenceId: null, //merchantId
      //   referenceType: 'merchant',
      //   name: '小程序主体证明',
      //   platfromType: 'wechatMini',
      //   code: 'evidence_small_program_body_proof'
      // },
      // {
      //   fileId: '',
      //   fileUrl: '',
      //   referenceId: null, //merchantId
      //   referenceType: 'merchant',
      //   name: '公众号主体证明',
      //   platfromType: 'wechat',
      //   code: 'evidence_webchat_proof'
      // },
      {
        fileId: '',
        fileUrl: '',
        referenceId: null, //merchantId
        referenceType: 'merchant',
        name: getLanguage()==='zh'?'入驻平台首页截图':'Screenshot of the homepage of the platform for entry',
        platfromType: 'settled',
        code: 'evidence_homepage_platform'
      },
      {
        fileId: '',
        fileUrl: '',
        referenceId: null, //merchantId
        referenceType: 'merchant',
        name: getLanguage()==='zh'?'入驻平台后台截图':'Screenshot of joining the platform backend',
        platfromType: 'settled',
        code: 'evidence_msystempage_platform'
      },
      {
        fileId: '',
        fileUrl: '',
        referenceId: null, //merchantId
        referenceType: 'merchant',
        name: getLanguage()==='zh'?'与入住平台签署的协议':'Agreement signed with the check-in platform',
        platfromType: 'settled',
        code: 'evidence_protocol_platform'
      }
    ],
    wechatMiniDocumentDtos:[
      {
        fileId: '',
        fileUrl: '',
        referenceId: null, //merchantId
        referenceType: 'merchant',
        name: getLanguage()==='zh'?'小程序主体证明':'Mini Program Entity Certificate',
        platfromType: 'wechatMini',
        code: 'evidence_small_program_body_proof'
      }
    ],
    wechatDocumentDtos:[
      {
        fileId: '',
        fileUrl: '',
        referenceId: null, //merchantId
        referenceType: 'merchant',
        name: getLanguage()==='zh'?'公众号主体证明':'Subject certification of official account',
        platfromType: 'wechat',
        code: 'evidence_webchat_proof'
      }
    ],
    merchantMaterialInfoDto: {
      merchantId: '', //商户编号
      province: '', //所属省份
      city: '', //所属城市
      engCountry: '', //所属国家
      engProvince: '', //所属英语省份
      engCity: '', //所属英语城市
      engAddress: '', //英文详细地址
      leaseContractId: '', //租赁合同
      leaseContract: '', //
      registerUnit: '', //注册资金单位
      natureOffice: '', //办公房屋产权性质
      areaOffice: '', //经营地址面积
      registerAddress1: '', //楼牌号
      engAddress1: '', //英文楼牌号
    },
    overseasAcquireInfoDto: {
      merchantId: '', //商户编号
      platformUrl: '',//平台网站URL
      platformIp: '',//平台网站IP地址
      overseasWebsiteInfoDtoList: [
        {
          transUrl: '',//交易网站URL
        }
      ],
      appId: '',
      singleMaxAmount: '',//单笔最高交易额（美元）
      singleMinAmount: '',//单笔最低交易额（美元）
      dayMaxAmount: '',//日最高交易额（美元）
      dayMinAmount: '',//日最低交易额（美元）
      dayMaxNumber: '',//日最高交易笔数
      dayMinNumber: '',//日最低交易笔数
      monthMaxAmount: '',//月最高交易额（美元）
      monthMinAmount: '',//月最低交易额（美元）
      monthMaxNumber: '',//月最高交易笔数
      monthMinNumber: '',//月最低交易笔数
      monthAverNumber: '',//月均交易笔数
      monthAverAmount: '',//月均交易金额（美元）
      yearMax: '',//年度内销量最高的月份（三个内）
      yearMin: '',//年度内销量最低的月份（三个内）
      monthRefuseNumber: '',//月平均拒付笔数
      monthRefuseAmount: '',//月平均拒付金额
      monthRefundNumber: '',//月平均退款笔数
      monthRefundAmount: '',//月平均退款金额
      yearBeforeAmount: '',//前一年营业额（美元）
      dbaName: '',//DBA名称（账单名称）
      mcc: '',//MCC
      recordIcpInfo: '',//网站ICP备案信息
      recordInfo: '',//网安备案信息/备案号
      webHomeId: '',//网站主页keyId
      webHomeUrl: '',//网站主页截图
      webContactId: '',//网站联系方式页面keyId
      webContactUrl: '',//网站联系方式页面截图
      webReturnId: '',//网站退换货及配送说明页面截图keyId
      webReturnUrl: '',//网站退换货及配送说明页面截图
      webPayId: '',//网站商品支付页面截图keyId
      webPayUrl: '',//网站商品支付页面截图
      officeId: '',//办公场所keyId
      officeUrl: '',//办公场所
      domainCertId: '',//域名证书keyId
      domainCertUrl: '',//域名证书
      riskDetectionId: '',//EC和Austreme的风险检测报告keyId
      riskDetectionUrl: '',//EC和Austreme的风险检测报告
      matchResultId: '',//MATCH扫描结果截图keyId
      matchResultUrl: '',//MATCH扫描结果截图
      pastTransId: '',//过往交易纪录及拒付、退款比例keyId
      pastTransUrl: '',//过往交易纪录及拒付、退款比例
      recentWaybillId: '',//近期运单截图keyId
      recentWaybillUrl: '',//近期运单截图
      specialIndustryId: '',//特殊行业许可证书keyId
      specialIndustryUrl: '',//特殊行业许可证书
    },
    overseasProductInfoDto: {
      merchantId: '', //商户编号
      rejectionRateList: [
        {
          name: '',
          rate: ''
        }
      ],//拒付率
      fraudRateList: [
        {
          name: '',
          rate: ''
        }
      ],//欺诈率
      refundRateList: [
        {
          name: '',
          rate: ''
        }
      ],//退款比率
      online: false,//线上收单形式
      offline: false,//线下收单形式
      cnyExperience: false,//人民币卡受理经验
      cnyTime: '',//开始受理日期
      cnyBank: '',//原收单银行
      foreExperience: false,//外币卡受理经验
      foreTime: '',//开始受理日期
      foreBank: '',//原收单银行
      acceptCard: '',//受理卡种
      instruction: false,//商品服务说明
      change: false,//退换货政策
      legal: false,//法律限制
      shipping: false,//送货政策
      service: false,//客服
      secrecy: false,//保密政策
      currency: false,//交易货币
      webSite: false,//网址
      privacy: false,//隐私
      country: false,//商户国家
      one: false,//1天-5天
      six: false,//6-10天
      eleven: false,//11-20天
      twentyOne: false,//21-30天
      moreThirty: false,//30天以上
      dues: false,//会员会费
      subscription: false,//订阅服务
      guarantee: false,//担保服务
      provide: false,//不提供
      websiteSecurity: '',//网站安全措施
      punishment: '',//是否受到卡组织惩罚
      business: '',//开展线上外卡收单业务
      refundInfo: '',//简述退换货时间与退换
    }
 })

 const cloneCertificationObj = lodash.cloneDeep(certificationObj)
 export function resetCertificationObj() {
   Object.assign(certificationObj, lodash.cloneDeep(cloneCertificationObj))
 }
export default certificationObj
